module.exports = __webpack_public_path__ + "static/media/bulk_couriers_mark_deliver_sample.08c4e210.csv";